import {
  finishSaving,
  saveActiveSkin,
  setActiveSkin,
  toggleSkinSelector,
} from '../actions/profileSkins';

import { handleActions } from 'redux-actions';
import { AppState } from '../../types/store';
import { ProfileSkinsSlice } from '../../types/profileSkins';

export default handleActions<AppState['profileSkins'], any>(
  {
    [setActiveSkin.toString()]: (
      state: ProfileSkinsSlice,
      action: ReturnType<typeof setActiveSkin>
    ) => {
      return {
        ...state,
        activeSkin: action.payload.skin,
      };
    },
    [saveActiveSkin.toString()]: (
      state: ProfileSkinsSlice,
      action: ReturnType<typeof saveActiveSkin>
    ) => {
      return {
        ...state,
        isSkinSaving: true,
      };
    },
    [toggleSkinSelector.toString()]: (
      state: ProfileSkinsSlice,
      action: ReturnType<typeof toggleSkinSelector>
    ) => {
      return {
        ...state,
        skinSelectorShown: !state.skinSelectorShown,
        isSkinSaving: false,
      };
    },
    [finishSaving.toString()]: (
      state: ProfileSkinsSlice,
      action: ReturnType<typeof finishSaving>
    ) => {
      return {
        ...state,
        isSkinSaving: false,
      };
    },
  },
  {
    skinSelectorShown: false,
    isSkinSaving: false,
  }
);
